export function NoIndex() {
  return <meta name="robots" content="noindex, nofollow" />;
}
